export class Proceso {
    idProceso: number;
    clave: string;
    descripcion: string;
    orden: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/proceso.ts